<template>
  <div class="history_header">
    <!-- <div class="history_area tabs">
      <div class="tab" :class="{active: searchParam.sale_type == null}" @click="change_sale_type(999999)">{{ t('すべて') }}</div>
      <div class="tab" :class="{active: searchParam.sale_type == 0}" @click="change_sale_type(0)">{{ t('即決価格') }}</div>
      <div class="tab" :class="{active: searchParam.sale_type == 1}" @click="change_sale_type(1)">{{ t('オークション') }}</div>
    </div> -->
    <div class="pending_area tabs">
      <div class="select-wrapper" @click="toggleDetailSearch(true)">
        <div class="detail-search-button">
          {{ t('詳細検索') }}
        </div>
        <span class="arrow"></span>
      </div>
    </div>
    <!-- 詳細検索オーバーレイ -->
    <div
      class="menu-overlay"
      :class="{ active: searchParam.showDetailSearch }"
      @click="toggleDetailSearch(false)"
    ></div>

    <!-- 詳細検索パネル -->
    <div
      class="detail-search-panel"
      :class="{ active: searchParam.showDetailSearch }"
    >
      <div class="close-button" @click="toggleDetailSearch(false)">×</div>
      <p class="search_title">{{ t('詳細検索') }}</p>
      <div class="content">
        <div class="content">
          <!-- キーワード検索 -->
          <TextBox
            class="keyword"
            type="text"
            :placeholder="t('キーワード検索')"
            v-model="searchParam.freeword"
          />
          <!-- カテゴリボタン -->
          <div class="category-buttons">
            <div
              class="category-button"
              v-for="(category, index) in decodedSelectType"
              :key="index"
            >
              <button
                class="category"
                :class="{ active: isActiveCategory(category.id) }"
                @click="selectCategory(category.id)"
              >
                {{ t(category.name) }}
              </button>
            </div>
          </div>
          <!-- チェックボックス -->
          <div class="checkboxes">
            <label>
              <input
                type="checkbox"
                :checked="searchParam.tokka_filter === 'exclude'"
                @change="toggleTokkaFilter('exclude')"
              />
              {{ t('傷あり品を除く') }}
            </label>
            <label>
              <input
                type="checkbox"
                :checked="searchParam.tokka_filter === 'only'"
                @change="toggleTokkaFilter('only')"
              />
              {{ t('傷あり品のみ表示') }}
            </label>
          </div>
          <!-- 価格帯 -->
          <div class="search_wrapper">
            <label>{{ t('価格帯') }}</label>
            <div class="price-range-box">
              <input
                type="number"
                v-model="searchParam.price_min"
                placeholder=""
              />
              <span class="tilde">〜</span>
              <input
                type="number"
                v-model="searchParam.price_max"
                placeholder=""
              />
            </div>
          </div>
          <!-- 表示順 -->
          <div class="search_wrapper">
            <label>{{ t('表示順') }}</label>
            <SelectBox
              :options="sortOptions"
              :selectedOption="searchParam.order_by"
              :placeholder="''"
              :isNoBorder="true"
              @handleSelectChange="handleSortChange"
            />
          </div>
          <!-- 販売中のみ表示 -->
          <div style="margin:10px 0;" class="is_sale">
            <label
              ><input type="checkbox" v-model="searchParam.is_sale" />
              {{ t('販売中のみ表示') }}</label
            >
          </div>
          <!-- ボタン -->
          <div class="button-group">
            <SimpleButton
              class="cancel-button"
              :text="t('クリア')"
              :isArrow="false"
              @handleSquareBtnClick="handleClear"
            />
            <SimpleButton
              class="purchase-btn"
              :text="t('検索')"
              :isArrow="false"
              @handleSquareBtnClick="handleSearch"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';
import TextBox from '@/components/atoms/TextBox.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';

export default {
  mixins: [t],

  components: {
    TextBox,
    SelectBox,
    SimpleButton,
  },

  props: {
    decodedSelectType: {
      type: Array,
      default: () => [],
    },
    searchParam: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      sortIds: ['price_desc', 'price_asc'],
    };
  },
  computed: {
    sortOptions() {
      const labelMap = {
        price_desc: this.t('価格が高い順'),
        price_asc: this.t('価格が安い順'),
      };
      return this.sortIds.map((id) => ({
        id,
        name: labelMap[id],
      }));
    },
  },

  methods: {
    isActiveCategory(id) {
      if (!this.searchParam.card_type) {
        return false;
      }
      return this.searchParam.card_type.includes(id);
    },
    selectCategory(categoryId) {
      if (this.searchParam.card_type.includes(categoryId)) {
        this.searchParam.card_type = this.searchParam.card_type.filter(
          (item) => item !== categoryId,
        );
      } else {
        this.searchParam.card_type.push(categoryId);
      }
    },
    toggleTokkaFilter(type) {
      // 同じものをもう一度押したら解除
      if (this.searchParam.tokka_filter === type) {
        this.searchParam.tokka_filter = '';
      } else {
        this.searchParam.tokka_filter = type;
      }
    },
    change_sale_type(type) {
      this.searchParam.sale_type = type;
      this.$emit('changeSaleType', this.searchParam.sale_type);
    },
    toggleDetailSearch(mode) {
      this.searchParam.showDetailSearch = mode;
      if (mode) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    },
    handleClear() {
      this.$emit('handleClear');
    },
    handleSortChange(val) {
      this.searchParam.order_by = val;
    },
    handleSearch() {
      this.toggleDetailSearch(false);
      this.$emit('handleSearch', this.searchParam);
    },
  },
};
</script>

<style lang="scss" scoped>
.history_header {
  margin-right: 2%;
  display: flex;
  // justify-content: space-between;
  justify-content: flex-end;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  .tabs {
    background-color: #eeeeee;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    .tab {
      padding: 5px 20px;
      border-radius: 10px;
      cursor: pointer;
      white-space: pre-wrap;
    }
    .tab.active {
      background-color: $white;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
  }
  .history_area {
    width: 80%;
  }
  .pending_area {
    width: 23%;
    justify-content: center;
    .select-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      cursor: pointer;
      .select {
        white-space: pre-wrap;
        width: 100%;
        height: 100%;
        padding: 5px 20px 5px 5px;
        border-radius: 10px;
        background-color: #ffffff;
        border: none;
        position: relative;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        appearance: none; // ブラウザのデフォルト矢印を消す
        -webkit-appearance: none;
        -moz-appearance: none;
      }
      .arrow {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 6px;
        height: 6px;
        pointer-events: none;
        border: solid black;
        border-width: 2px 2px 0 0;
        transform: translateY(-50%) rotate(135deg);
      }
    }
  }
  .menu-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: none;
    z-index: 1000;
  }
  .menu-overlay.active {
    display: block;
  }

  .detail-search-panel {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 350px;
    background: white;
    transform: translateX(105%);
    transition: transform 0.3s ease;
    z-index: 1001;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    padding: 20px;
    color: $gray2;
    overflow-y: auto;
    font-size: 16px;
    &.active {
      transform: translateX(0);
    }
    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 28px;
      cursor: pointer;
    }
    .search_title {
      font-size: 25px;
      text-align: center;
    }
    .keyword {
      width: 100%;
      padding: 10px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
      border-radius: 24px;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .category-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 11px;
      margin: 20px 0;
      .category {
        padding: 6px 12px;
        background-color: #ffffff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
        border-radius: 6px;
        cursor: pointer;
        &.active {
          background: #182f5c42;
          color: #fff;
        }
      }
    }
    .checkboxes {
      justify-content: space-around;
      display: flex;
      gap: 15px;
      margin: 15px 0;
    }
    .search_wrapper {
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 5px;
      margin: 15px 0;
      .price-range-box {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between; // ← 左右にしっかり間隔をあける
        padding: 0px 12px;
        input {
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
          width: 40%;
          padding: 8px 10px;
          border: none;
          font-size: 16px;
          border-radius: 6px;
        }
        .tilde {
          margin: 0 10px;
          font-size: 18px;
          color: #333;
          white-space: nowrap;
        }
      }
      .select-box {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
        width: 90%;
        align-self: center;
      }
    }
    .button-group {
      display: flex;
      justify-content: space-around;
      margin-top: 30px;
      .purchase-btn {
        width: 40%;
        font-size: 16px;
        font-weight: bold;
        @media screen and (max-width: $tabletWidth) {
          padding: 10px;
        }
      }
      .cancel-button {
        color: #a1a2a2;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .history_header {
    margin-right: 0;
    font-size: 11px;
    .tabs {
      padding: 5px;
      .tab {
        padding: 5px 7px;
      }
    }
    .history_area {
      width: 75%;
    }
    .pending_area {
      width: 23%;
    }
  }
}
</style>
